import React from "react";

const Switch = ({ isOn, handleToggle, onLabel, offLabel }) => {
  return (
    <div className="flex items-center space-x-4">
      <span className="text-gray-700 font-medium">{offLabel}</span>
      <div
        className={`relative inline-block w-10 h-6 transition duration-200 ease-linear rounded-full ${
          isOn ? "bg-blue-500" : "bg-gray-300"
        }`}
        onClick={handleToggle}
      >
        <span
          className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform transform ${
            isOn ? "translate-x-full" : ""
          }`}
        />
      </div>
      <span className="text-gray-700 font-medium">{onLabel}</span>
    </div>
  );
};

export default Switch;
